import { i18n } from "commonAssets/js/constants";
import { toggleFieldError } from "./toggleFieldError.js";
import { validRequire } from "./validRequire.js";
import { validInteger } from "./validInteger.js";
import { validFloat } from "./validFloat.js";
import { validPrice } from "./validPrice.js";
import { validMin } from "./validMin.js";
import { validMax } from "./validMax.js";
import { validEmail } from "./validEmail.js";
import { validURL } from "./validURL.js";
import { validMinLength } from "./validMinLength.js";
import { validMaxLength } from "./validMaxLength.js";
import { validZipCode } from "./validZipCode.js";
import { validPhone } from "./validPhone.js";
import { validFileType } from "./validFileType.js";
import { validFileSize } from "./validFileSize.js";
import { validMonth } from "./validMonth.js";
import { validDate } from "./validDate.js";
import { validMinDate } from "./validMinDate.js";
import { validMaxDate } from "./validMaxDate.js";
import { validGreaterThan } from "./validGreaterThan.js";
import { validLessThan } from "./validLessThan.js";
import { validRegex } from "./validRegex.js";
import { formatDate } from "./formatDate.js";

export function validateField(e) {
    const field = e instanceof Event ? e.target : e;

    if (!field.hasAttribute("data-validate")) {
        return;
    }

    // Check if this is an intl-phone-input custom element
    if (field.tagName?.toLowerCase() === "intl-phone-input") {
        return field.validate();
    }

    // Check if this is an ssn-input custom element
    if (field.tagName?.toLowerCase() === "ssn-input") {
        return field.validate();
    }

    const validation = field.getAttribute("data-validate").split(" ");

    // File input element values can't be changed (except to empty string)
    if (field.type != "file") {
        field.value = field.value.trim();
    }

    if (
        field.hasAttribute("data-custom-validate") &&
        typeof customValidateField === "function"
    ) {
        return customValidateField(field, validation);
    }

    toggleFieldError(field, false);

    if (validation.includes("required") && !validRequire(field)) {
        toggleFieldError(field, true, i18n.getTranslation("required"));
        return false;
    }

    if (field.value) {
        if (validation.includes("integer") && !validInteger(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("float") && !validFloat(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("price") && !validPrice(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (field.min && !validation.includes('date-min') && !validMin(field)) {
            toggleFieldError(field, true, `Must be at least ${field.min}`);
            return false;
        }

        if (field.max && !validation.includes('date-max') && !validMax(field)) {
            toggleFieldError(field, true, `Must be at most ${field.max}`);
            return false;
        }

        if (validation.includes("email") && !validEmail(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("url") && !validURL(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("min-length") && !validMinLength(field)) {
            toggleFieldError(
                field,
                true,
                "Min Length: " + field.getAttribute("data-min-length")
            );
            return false;
        }

        if (validation.includes("max-length") && !validMaxLength(field)) {
            toggleFieldError(
                field,
                true,
                "Max Length: " + field.getAttribute("data-max-length")
            );
            return false;
        }

        if (validation.includes("zip-code") && !validZipCode(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("phone") && !validPhone(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("file-type") && !validFileType(field)) {
            toggleFieldError(field, true, "Invalid File Type");
            return false;
        }

        if (validation.includes("file-size") && !validFileSize(field)) {
            toggleFieldError(
                field,
                true,
                "Max File Size: " +
                    field.getAttribute("data-file-size") / 1048576 +
                    " Mb"
            );
            return false;
        }

        if (validation.includes("month") && !validMonth(field)) {
            toggleFieldError(field, true, "Must be in format MM/YYYY");
            return false;
        }

        if (validation.includes("date") && !validDate(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }

        if (validation.includes("date-min") && !validMinDate(field)) {
            toggleFieldError(
                field,
                true,
                `Minimum date is ${formatDate(field.getAttribute("data-date-min"))}`
            );
            return false;
        }

        if (validation.includes("date-max") && !validMaxDate(field)) {
            toggleFieldError(
                field,
                true,
                `Maximum date is ${formatDate(field.getAttribute("data-date-max"))}`
            );
            return false;
        }

        if (validation.includes("greater-than") && !validGreaterThan(field)) {
            toggleFieldError(field, true, "Invalid"); //'Greater Than: '+field.getAttribute('data-greater-than'));
            return false;
        }

        if (validation.includes("less-than") && !validLessThan(field)) {
            toggleFieldError(field, true, "Invalid"); //'Less Than: '+field.getAttribute('data-less-than'));
            return false;
        }

        if (validation.includes("regex") && !validRegex(field)) {
            toggleFieldError(field, true, "Invalid");
            return false;
        }
    }

    return true;
}
